import DatasetColumn from "./DatasetColumn";
import DatasetRow from "./DatasetRow";
import DatasetCell from "./DatasetCell";
import Hash from "../utils/Hash";
import Model from "./Model";

export default class Dataset extends Model {

	constructor(props) {

		super({});

		const mapper = `/**
 * Transform the response variable into a valid Polymind dataset
 * structure.
 */
response = JSON.parse(response);

return {
    columns: [
        { name: 'Name', lang: 'en' },
        { name: 'Email', lang: 'en' },
        { name: 'Phone', lang: 'en' },
    ],
    rows: response.map(entry => {
        return {
            cells: [
                { text: entry.name },
                { text: entry.email },
                { text: entry.phone },
            ]
        };
    })
};`;

		this.setDefaultValues({
			id: null,
			guid: Hash.guid(),
			name: '',
			description: '<p></p>',
			is_private: false,
			is_remote: false,
			remote_uri: 'https://jsonplaceholder.typicode.com/users',
			is_applying_mapper: false,
			mapper: mapper,
			icon: '',
			columns: [],
			rows: [],
		}, props);

		this.columns = this.columns.map(column => new DatasetColumn(column));
		this.rows = this.rows.map(row => new DatasetRow(row));

		this.validate();
	}

	clean() {
		this.columns = this.columns.map(column => {
			return column.flat(false);
		});
		this.rows = this.rows.map(row => {
			row.cells = row.cells.map(cell => {
				return cell.flat(false);
			});
			return row.flat(false, true);
		});
		return this.flat(false, true);
	}

	getRemote() {
		return fetch(this.remote_uri)
			.then(response => response.text())
			.then(response => {
				if (this.is_applying_mapper) {
					return new Dataset(Object.assign({}, this, eval('() => {' + this.mapper + '}')())).clean();
				}

				return new Dataset(Object.assign({}, this, response.data)).clean();
			});
	}

	/**
	 * Make sure all cells are existing
	 */
	validate() {

		this.rows.forEach(row => {
			const columnDiff = this.columns.length - row.cells.length;
			if (columnDiff !== 0) {
				for (let i = 0; i < columnDiff; i++) {
					row.cells.push(new DatasetCell());
				}
			}
		});
	}
}
